// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R

import i18n from 'i18n';
import { toast } from 'react-toastify';
import { createAxios } from 'ts/createAxios';
import { getApiPath } from 'util/commons';
import { API_ENDPOINTS } from 'util/endPoints';
import { handleError } from 'util/errorHandler';
import { MasterProductForm, MasterProductResponse } from 'util/Types';

export const handleFetchMasterProducts = async (params: {
  siteId: string;
  successCallback?: (data: MasterProductResponse) => void;
}) => {
  const { siteId, successCallback } = params;

  try {
    const { data } = await createAxios().get<MasterProductResponse>(
      API_ENDPOINTS.MASTER_PRODUCTS,
      {
        params: {
          siteId,
        },
      }
    );

    successCallback?.(data);
  } catch (error) {
    handleError(error);
  }
};

export const handleCreateMasterProduct = async (p: {
  params: MasterProductForm;
  successCallback?: () => void;
}) => {
  const { params, successCallback } = p;

  try {
    await createAxios().post(API_ENDPOINTS.MASTER_PRODUCTS, params);

    toast.success(i18n.t('messages.M_010'));
    successCallback?.();
  } catch (error) {
    handleError(error);
  }
};

export const handleUpdateMasterProduct = async (p: {
  id: string;
  params: MasterProductForm;
  successCallback?: () => void;
}) => {
  const { id, params, successCallback } = p;

  try {
    await createAxios().put(
      getApiPath(API_ENDPOINTS.MASTER_PRODUCTS_DETAIL, { id }),
      params
    );

    toast.success(i18n.t('messages.M_011'));
    successCallback?.();
  } catch (error) {
    handleError(error);
  }
};

export const handleDeleteMasterProduct = async (params: {
  id: string;
  successCallback?: () => void;
}) => {
  const { id, successCallback } = params;

  try {
    await createAxios().delete(
      getApiPath(API_ENDPOINTS.MASTER_PRODUCTS_DETAIL, { id })
    );

    toast.success(i18n.t('messages.M_012'));
    successCallback?.();
  } catch (error) {
    handleError(error);
  }
};
